/* eslint-disable internal-rules/agg-product-areas */
import { basicPipeline, processVocItemFilters } from '@/voc/helpers/aggs.helper';
import { EXPLORE_STATUSES, getExploreStatus } from '@/voc/helpers/permissions.helper';
import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@utils/aggregation';

const { VOC } = PRODUCT_AREAS || {};
const { CAPTURE } = SUB_PRODUCT_AREAS || {};

export default {
    name: 'VocItemCountsAggregation',
    productArea: VOC,
    subProductArea: CAPTURE,
    responseFormat: 'row',
    build: ({ filters = {}, type = 'feedback', accountTypeField, disableDatastoreIterator = false }) => {
        const selectFields = ['id', 'vocInsightIds'];
        filters = processVocItemFilters(filters);
        const pipelineData = [];

        if (filters.vocInsightIds.length === 0) {
            const hasVocInsightLevelFilters = filters.feedbackType.length > 0 || filters.alert.length > 0 || filters.competitorNames.length > 0;
            const agg = basicPipeline({
                ...filters,
                type,
                accountTypeField,
                selectFields,
            });

            pipelineData.push(
                ...[
                    agg.source,
                    ...agg.pipeline,
                    ...(agg.fork.length > 1 ? [o.fork(...agg.fork), o.join('id')] : []),
                    ...(agg.fork.length === 1 ? agg.fork[0] : []),
                    ...(agg.postFork.length ? o.pipeline(...agg.postFork) : []),
                    o.select(selectFields),
                    ...(hasVocInsightLevelFilters || getExploreStatus() !== EXPLORE_STATUSES.READY
                        ? [
                            o.fork(
                                o.pipeline(o.reduce({ totalInsights: o.count(null) })),
                                o.pipeline(o.reduce({ totalVocItems: o.count('id') })),
                            ),
                        ]
                        : [
                            o.fork(
                                o.pipeline(o.reduce({ totalVocItems: o.count(null) })),
                                o.pipeline(
                                    o.unwind('vocInsightIds'),
                                    o.merge(
                                        ['vocInsightIds'],
                                        {},
                                        o.pipeline(
                                            o.sources.vocInsights({
                                                disableDatastoreIterator,
                                            }),
                                            ...(filters.groups?.length
                                                ? [
                                                    o.filter(
                                                        filters.groups
                                                            .map((group) => {
                                                                const id =
                                                                        group?.id === undefined ? group : group.id;
                                                                if (id === '') {
                                                                    return 'len(productAreaId) == 0';
                                                                }

                                                                return `contains(productAreaId, "${id}")`;
                                                            })
                                                            .join(' || '),
                                                    ),
                                                ]
                                                : []),
                                            o.select({
                                                vocInsightIds: 'id',
                                                vocInsightId: 'id',
                                            }),
                                        ),
                                    ),
                                    o.filter('!isNull(vocInsightId)'),
                                    o.reduce({ totalInsights: o.count(null) }),
                                ),
                            ),
                        ]),
                    o.join(),
                ],
            );
        } else {
            pipelineData.push(
                ...[
                    o.sources.vocInsights({
                        disableDatastoreIterator,
                    }),
                    o.filter(filters.vocInsightIds.map((id) => `id == "${id}"`).join(' || ')),
                    o.fork(
                        o.pipeline(o.reduce({ totalInsights: o.count(null) })),
                        o.pipeline(o.reduce({ totalVocItems: o.count('vocItemKey') })),
                    ),
                    o.join(),
                ],
            );
        }

        return o.pipeline(pipelineData);
    },
};
